export interface IExchDetail {
  exchId: string | number
  exchName: string
  exchJSON: any
  exchUrl: string
  exchCode: string
  heatIndex: number | string
  exchNumCurrencies: number | string
  exchNumMarkets: number | string
  exchVolume24: number | string
  exchBalanceEnabledV2: boolean | string
  exchTradeEnabledV2: boolean | string
  hasSpotTrading: boolean | string
  hasFuturesTrading: boolean | string
  prevSlug: string
  nextSlug: string
  prevSlugName: string
  nextSlugName: string
}

export class ExchDetail implements IExchDetail {
  constructor(
    public exchId: string | number = '',
    public exchName: string = '',
    public exchJSON: any = '',
    public exchUrl: string = '',
    public exchCode: string = '',
    public heatIndex: number | string = '',
    public exchNumCurrencies: number | string = '',
    public exchNumMarkets: number | string = '',
    public exchVolume24: number | string = '',
    public exchBalanceEnabledV2: boolean | string = '',
    public exchTradeEnabledV2: boolean | string = '',
    public hasSpotTrading: boolean | string = '',
    public hasFuturesTrading: boolean | string = '',
    public prevSlug: string = '',
    public nextSlug: string = '',
    public prevSlugName: string = '',
    public nextSlugName: string = ''
  ) {}
}

export default ExchDetail 